/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  .placeholder-large {
    background: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    padding: 10px 0;
    text-align: center;
    width: calc(100% - 26px);
    margin: 0 13px ${(props) => props.theme.spacing.ELEM_SPACING.MED};

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0 13px ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0 13px ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    }
  }
  .placeholder-small {
    background: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    padding: 20px 0;
    text-align: center;
    width: 100%;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XL} 0;

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: ${(props) => props.theme.spacing.ELEM_SPACING.XXL} 0;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: ${(props) => props.theme.spacing.ELEM_SPACING.XL} 0;
    }
  }

  .breadcrumb-container {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-top: 16px;
    }
  }

  .breadcrum-wrapper {
    margin: 0 0 16px;

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) =>
        props.isBundlePageRedesign
          ? `margin: 0 0 ${props.theme.spacing.ELEM_SPACING.LRG};`
          : `margin: 0 0 ${props.theme.spacing.ELEM_SPACING.XXL};`}
    }
  }
  .back-to-collections-container {
    margin-bottom: 24px;

    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-top: 16px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-bottom: 16px;
      margin-top: 16px;
    }
  }
  .back-to-collections-button {
    border: none;
    display: flex;
    align-items: center;
    column-gap: 10px;
    background: unset;
    padding: 0;
    cursor: pointer;
  }
  .back-to-collections-left-arrow {
    height: 14px;
  }
  .back-to-collections-label {
    color: #005d95;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
  }
  .title-wrapper {
    display: block;
    @media ${(props) => props.theme.mediaQuery.large} {
      display: flex;
    }
  }
  .wishlist-container {
    width: 25px;
  }
  .bundle-products-list {
    margin: 0;
    width: 100%;
  }
  .product-detail-section {
    flex: 1;
    margin: 0;
  }
  .product-image-wrapper {
    margin-right: 0;
  }
  .product-detail-image-wrapper {
    margin-bottom: 8px;
  }
  .product-summary-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .bundle-social-wrapper {
    justify-content: right;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
  .product-summary-section {
    ${(props) =>
      !props.isBundlePageRedesign &&
      `border-bottom: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
       padding-bottom: ${props.theme.spacing.ELEM_SPACING.XL};
       margin-bottom: ${props.theme.spacing.ELEM_SPACING.LRG};`}
  }
  .bundle-product-item {
    border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    &:last-child {
      border-bottom: 0;
    }
  }
  .product-container {
    ${(props) =>
      !props.isBundlePageRedesign &&
      `border-bottom: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};margin-bottom: ${props.theme.spacing.ELEM_SPACING.LRG};`}
  }

  .original-price {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    }
  }
  .actual-price {
    font-size: ${(props) => props.theme.typography.fontSizes.fs22};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs24};
      margin-top: 0;
    }
  }

  .outfiting-list-details {
    .actual-price {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy7};
    }
    .original-price {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    .outfit-mobile-image img {
      height: 200px;
      width: 100%;
      object-fit: contain;
    }

    .outfit-carousal-image {
      object-fit: contain;
      width: 100%;
    }
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .product-image-wrapper {
      margin-right: 30px;
    }
    .product-detail-image-wrapper {
      margin-bottom: 11px;
    }
    .product-summary-mobile-view {
      display: none;
    }
    .product-summary-desktop-view {
      display: flex;
    }
    .product-price-mobile-view {
      display: none;
    }
    .product-price-desktop-view {
      display: flex;
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .product-image-wrapper {
      margin-right: 0;
    }
    .product-detail-image-wrapper {
      margin-bottom: 27px;
    }
    .product-summary-mobile-view {
      display: none;
    }
    .product-summary-desktop-view {
      display: flex;
    }
    .product-price-mobile-view {
      display: none;
    }
    .product-price-desktop-view {
      display: flex;
      border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }
  .syte-container-wrapper {
    position: relative;
  }
  .syte-discovery {
    position: absolute;
    top: -60px;
    margin-left: 0;
    margin-bottom: -42px;
    right: 20px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      right: 22px;
      top: -50px;
    }
  }

  .main-bundle-image,
  .main-bundle-image .full-size-desktop-image {
    ${(props) => {
      if (props.isCombinedKitsEnabled) {
        return props.isBundlePageRedesign
          ? ` width: 350px;
    height: auto;
    @media ${props.theme.mediaQuery.large} {
      width: 384px;
    }
    `
          : '';
      }
      return props.isBundlePageRedesign
        ? ` width: 267px;
    height: auto;`
        : '';
    }}
  }

  .main-bundle-image.collection-zoom-image {
    position: relative;

    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      a {
        pointer-events: unset;
      }
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: 32px;
    }
  }

  .build-your-experience-main-bundle-image .full-size-desktop-image {
    min-width: 350px;
    @media ${(props) => props.theme.mediaQuery.large} {
      min-width: 384px;
    }
  }

  .build-your-experience-main-bundle-image img,
  .build-your-experience-main-bundle-image video {
    border-radius: 12px;
  }

  .build-your-experience-main-bundle-image {
    height: max-content;
  }

  .main-bundle-image {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isBundlePageRedesign
          ? ` width: 100%;
          height: auto;`
          : ''}
    }
  }

  .main-bundle-image .full-size-desktop-image {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isBundlePageRedesign
          ? `  width: 100%;
          height: auto;`
          : ''}
    }
  }
  .product-price-col {
    padding-bottom: 24px;
    border-bottom: 1px solid ${(props) => props.theme.colors.DIVIDER};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: ${({ theme }) => theme.spacing.ELEM_SPACING.LRG};
    }
  }
  .main-bundle-image .product-price-col {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => (props.isBundlePageRedesign ? `   border-bottom: 0;` : '')}
    }
  }

  .main-bundle-description {
    flex-grow: 1;
    margin-right: 0;
    ${({ isCombinedKitsEnabled, isBundlePageRedesign, theme }) =>
      isCombinedKitsEnabled && isBundlePageRedesign
        ? `@media ${theme.mediaQuery.large} {
      display: flex;
      flex-direction: column;
    }`
        : ''}
  }
  .product-summary-wrapper-new-design {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .title-wrapper-new-design {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy6}px;
    line-height: 27px;
    margin: 0;
  }
  .bundle-social-wrapper-redesign {
    justify-content: right;
  }
  .product-desc-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .product-desc-title-text,
  .product-desc-title-partno {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  }
  .product-desc-title-text {
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
  }
  .product-desc-title-partno {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy1}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
    color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
  }
  .list-child {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .price-container {
    ${(props) => props.isBundlePageRedesign && `display: flex`};
  }
  .product-price-container {
    ${(props) =>
      props.isBundlePageRedesign &&
      `padding-bottom: ${props.theme.spacing.ELEM_SPACING.LRG};
    @media ${props.theme.mediaQuery.smallOnly}{
      border-bottom: 0;
      padding-bottom: 0;
    }
    `};
  }

  .list-badge-container {
    ${(props) =>
      props.isBundlePageRedesign && ` margin-left: ${props.theme.spacing.ELEM_SPACING.XS_1};`};
  }
  .icon-pinterest {
    ${(props) =>
      props.isBundlePageRedesign &&
      `@media ${props.theme.mediaQuery.mediumMax} {
     margin-right: ${props.theme.spacing.ELEM_SPACING.REG};
    }`};
  }

  .icon-facebook .facebook,
  .icon-pinterest .pinterest,
  .icon-twitter .twitter {
    ${(props) => {
      return (
        props.isBundlePageRedesign &&
        `
      height: ${props.theme.spacing.ELEM_SPACING.LRCX};
      width: ${props.theme.spacing.ELEM_SPACING.LRCX};

      @media ${props.theme.mediaQuery.mediumMax} {
        height:${props.theme.spacing.APP_LAYOUT_SPACING.XS};
        width:${props.theme.spacing.APP_LAYOUT_SPACING.XS};
      }`
      );
    }};
  }

  .product-description {
    margin-top: 24px;
  }

  .combined-kits-caraosal .slick-arrow,
  .main-bundle-image .slick-arrow {
    ${(props) =>
      props.isBundlePageRedesign
        ? `
        background: url(${getIconPath('icon-carrot-grey-large')}) no-repeat center center;
        background-color: ${props.theme.colors.WHITE};
        opacity: 0.9;
        border: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
        border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6};
        height: ${props.theme.spacing.ELEM_SPACING.XXL};
        width: ${props.theme.spacing.ELEM_SPACING.XXL};
    `
        : ``}
  }

  .combined-kits-caraosal .slick-disabled,
  .main-bundle-image .slick-disabled {
    ${(props) =>
      props.isBundlePageRedesign &&
      `
   display: none !important;
    `}
  }

  .main-bundle-image .slick-dots {
    ${(props) =>
      props.isBundlePageRedesign &&
      `
      bottom: -${props.theme.spacing.ELEM_SPACING.XXS};
    `}
  }

  .main-bundle-image .slick-dots ul {
    ${(props) =>
      props.isBundlePageRedesign &&
      `
      background-color: ${props.theme.colors.PRIMARY.LIGHTGRAY};
    `}
  }

  .main-bundle-image .slick-dots ul,
  .main-bundle-image .slick-dots li button:before {
    width: 100%;
  }

  .main-bundle-image .slick-dots li button:before {
    ${(props) =>
      props.isBundlePageRedesign &&
      `
      height: ${props.theme.spacing.ELEM_SPACING.XXS};
      background-color:${props.theme.colors.PRIMARY.LIGHTGRAY};
    `}
  }

  .main-bundle-image .slick-dots li,
  .main-bundle-image .slick-dots li button {
    ${(props) =>
      props.isBundlePageRedesign &&
      `
      height: ${props.theme.spacing.ELEM_SPACING.XXS};
      flex-grow: 1;
    `}
  }

  .main-bundle-image .slick-dots .slick-active,
  .main-bundle-image .slick-dots .slick-active button:before {
    ${(props) =>
      props.isBundlePageRedesign &&
      `
      background-color: ${props.theme.colors.PRIMARY.DARK};
      border-radius: ${props.theme.spacing.ELEM_SPACING.XXS};
    `}
  }
  .combined-kits {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: auto;
    }
  }
  .combined-kits-wrapper {
    margin-top: ${({ theme }) => theme.spacing.ELEM_SPACING.LRG};
  }
  .combined-kit-container {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: auto;
    }
  }
  .combined-kit-container.remove-margin-top {
    margin-top: unset;
  }

  .carousel-desktop-width {
    @media (min-width: 1315px) {
      width: 873px !important;
    }
  }

  .related-bundle-carousal-image div {
    width: 68px;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 85px;
    }
    padding-top: ${({ theme }) => theme.spacing.ELEM_SPACING.SM};
    padding-bottom: ${({ theme }) => theme.spacing.ELEM_SPACING.SM};
    border-bottom: 3px solid ${({ theme }) => theme.colors.TRANSPARENT};
  }
  .related-bundle-carousal-image img {
    border: 1px solid ${({ theme }) => theme.colors.PRIMARY.GRAY};
    border-radius: ${({ theme }) => theme.spacing.ELEM_SPACING.XS_6};
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 106px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      min-height: 86px;
    }
  }
  .related-bundle-carousal-image.active div {
    border-bottom: 3px solid ${({ theme }) => theme.colors.BUTTON.BLUE.NEW_FILTER_BTN};
  }
  .combined-kits-caraosal .show-on-mobile p {
    min-height: auto !important;
  }
  .combined-kit-skeleton {
    margin-top: auto;
    height: 137px;
  }
  .related-bundle-carousal-anchor.active {
    @media ${(props) => props.theme.mediaQuery.large} {
      cursor: unset;
    }
  }

  .combined-kits-caraosal.scroll-container-combined-kits {
    display: flex;
    overflow-x: scroll;
    column-gap: ${(props) => props.theme.spacing.ELEM_SPACING.SM};

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .plp-grid {
    display: grid;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    @media ${(props) => props.theme.mediaQuery.small} {
      grid-template-columns: auto auto;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      grid-template-columns: auto auto auto auto;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      grid-template-columns: 288px 288px 288px 288px 288px;
    }
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      grid-template-columns: 288px 288px 288px 288px 288px;
    }
  }
  .plp-grid-skelton {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 24px;
    padding-top: 24px;
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    padding-bottom: 7px;

    @media ${(props) => props.theme.mediaQuery.small} {
      grid-template-columns: repeat(auto-fill, minmax(163px, 1fr));
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      grid-column-gap: 32px;
      padding-top: 32px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      grid-column-gap: 16px;
      grid-row-gap: 64px;
      grid-template-columns: repeat(auto-fill, minmax(264px, 1fr));
      padding-bottom: 19px;
    }
  }
  .bundle-product-grid-skeleton {
    margin: 0;
    width: 100%;
  }

  .build-your-experience-pj-planner-container {
    @media ${(props) => props.theme.mediaQuery.medium} {
      flex-wrap: nowrap;
    }
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .build-your-experience-pj-planner-container .build-your-experience-main-bundle-image {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-right: 16px;
    }
  }

  .hide-mpr {
    .mpr {
      display: none;
    }
  }

  .enlarged-image-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${(props) => props.theme.zindex.zEnlargedImage};
  }
  .enlarged-image {
    position: absolute;
    z-index: ${(props) => props.theme.zindex.zEnlargedImage};
    height: 100%;
    img {
      max-width: none;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: calc(384px + 32px);
    }
  }

  .enlarged-image-wrapper {
    height: 0;
    z-index: 100;
    border: 1px solid ${(props) => props.theme.colors.BORDER.NORMAL};
  }

  .pdp-img-overlay {
    height: 0;
    overflow: hidden;
    position: relative;
    padding-top: 154%;
    transform-origin: 0 0;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      padding-top: 120%;
    }
  }
  .pdp-img-overlay .product-img-slider {
    position: absolute;
    width: 94%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media screen and (orientation: landscape) {
    .pdp-img-overlay {
      padding-top: 62%;
    }
    .pdp-img-overlay .product-img-slider {
      width: 45%;
    }
  }
  @media screen and (max-height: 430px) and (orientation: landscape) {
    .pdp-img-overlay {
      padding-top: 31%;
    }
    .pdp-img-overlay .product-img-slider {
      width: 22%;
    }
  }

  .pdp-img-overlay .product-img-slider .slick-initialized {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      overflow: hidden;
    }
  }
`;
